import { IFilterDef } from './layer-filter.interface'

export interface ILayerConfig {
    id: string;
    layer: ILayerConfigLayer;
    layers?: any[];  // Dynamic layers array for map layer selector
}

export interface ILayerConfigLayer {
    type: LayerConfigLayerTypeEnum;
    url: string;
    wms: ILayerConfigLayerWms;
    filter: IFilterDef;
    sldBody: ILayerConfigLayerSldBody;
}

export interface ILayerConfigLayerWms {
    layers: string;
    format: string;
    transparent: boolean;
    unloadInvisibleTiles: boolean;
    noWrap: boolean;
    zIndex: number;
}

export interface ILayerConfigLayerSldBody {
    name: string;
    rules: Array<ILayerConfigLayerSldBodyRule>;
}

export interface ILayerConfigLayerSldBodyRule {
    name: string;
    polygonSymbolizer?: {
        fill: {
            svgParameter: {
                fill: string;
                'fill-opacity': number;
            };
        };
        stroke: {
            svgParameter: {
                stroke: string;
                'stroke-width': number;
            };
        };
    };
    textSymbolizer?: {
        label?: string;
        font?: {
            svgParameter?: Array<any>;
        };
        labelPlacement?: {
            pointPlacement?: {
                anchorPoint?: {
                    anchorPointX?: number;
                    anchorPointY?: number;
                };
            };
        };
        halo?: {
            radius?: number;
            fill?: {
                svgParameter?: Array<any>;
            };
        };
        fill?: {
            svgParameter?: Array<any>;
        };
    };
}

export enum LayerConfigLayerTypeEnum {
    wms = 'wms'
}